import Vue from 'vue'
import Vuex from 'vuex'
import pers from 'vuex-persistedstate'
import getters from './getters'

Vue.use(Vuex)

const state ={
  info:{
    username:null,
    vip:'0',
  }

}

const mutations = {
	addsession(state,userinfo){
		state.info.username = userinfo
	},
  addvip(state,vip){
		state.info.vip = vip
	},
}
const actions = {

}

const modules = {

}

export default new Vuex.Store({
	plugins:[pers()],
  state,
  mutations,
  actions,
	getters,
  modules
})
